// Styles import
import '../assets/styles/css/Footer.css'

// Translate import
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import logoVV from '../assets/img/VVLOGO.png'
import dropdown from '../assets/img/dropdown.svg'

function Footer(props) {
  const {
    i18n: { changeLanguage },
    t,
  } = useTranslation()

  return (
    <div className='footer'>
      <div className='footerCnt'>
        <div>
          <div className='logoVVfooter'>
            <img alt='logo' src={logoVV} />
          </div>
          <p>{t('Copyright © 2018 Vicens Vives')}</p>
        </div>
        <div>
          <div className='language'>
            <div className='dropdownIcon'>
              <img alt='dropdown' src={dropdown} />
            </div>
            <select
              defaultValue='es'
              id='selectlang'
              onChange={(event) => changeLanguage(event.target.value)}
            >
              <option value='es'>{t('Español')}</option>
              {/* WIP: Desactivamos el idioma CATALÁN para Enquijotados y Gramatica hasta que pasen las traducciones oficiales */}
              {props.showCatLang && <option value='ca'>{t('Català')}</option>}
            </select>
          </div>
        </div>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  showCatLang: true,
}

Footer.propTypes = {
  showCatLang: PropTypes.bool,
}
export default Footer
